var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('img',{staticClass:"header__logo",attrs:{"src":require("@/assets/imgs/logo.svg")}}),_c('v-btn',{staticClass:"header__btn",attrs:{"outlined":""},on:{"click":_vm.goToHome}},[_vm._v(" Sobre nosotros "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" mdi-arrow-right ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }